import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-turns-parameters-rules-card',
  templateUrl: './turns-parameters-rules-card.component.html',
  styleUrls: ['./turns-parameters-rules-card.component.scss']
})
export class TurnsParametersRulesCardComponent implements OnInit {

  @Input() data;
  enableCount: any;
  showCounter: boolean;

  constructor( private spinnerService: SpinnerService ) { }

  ngOnInit() {
  }

}
